import { Materia } from '../@types';
import Service from './Service';

class MateriaService extends Service {
  static getMaterias() {
    return this.Http.get<Materia.Materia[]>(
      '/subjects'
    ).then(this.getData);
  }
  static getEstatisticasMaterias() {
    return this.Http.get<Materia.SubjectStats[]>(
      '/subjects/stats'
    ).then(this.getData);
  }

  static getMateria(id: string) {
    return this.Http.get<Materia.Materia>(
      `/subjects/${id}`
    ).then(this.getData);
  }

  static inserirNovaMateria(materia: Materia.Materia) {
    return this.Http.post<Materia.Materia>(
      '/subjects',
      materia
    ).then(this.getData);
  }

  static atualizarMateria(materia: Materia.Materia) {
    return this.Http.put<Materia.Materia>(
      `/subjects/${materia.id}`,
      materia
    ).then(this.getData);
  }

  static deletarMateria(id: string) {
    return this.Http.delete(`/subjects/${id}`).then(this.getData);
  }
}

export default MateriaService;
